// frontend/src/components/auth/ResetPassword.jsx
import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { authService } from "../../services/auth";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState(token ? "idle" : "no-token");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setStatus("submitting");
    try {
      await authService.resetPassword(token, password);
      setStatus("success");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
      setStatus("idle");
    }
  };

  if (status === "no-token") {
    return (
      <div className="login-container">
        <div className="login-box" style={{ textAlign: "center" }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "rgba(211, 47, 47, 0.12)",
              fontSize: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem",
            }}
          >
            ⚠️
          </div>
          <h2>Invalid link</h2>
          <p style={{ color: "var(--text-secondary, #666666)", marginBottom: "1.5rem" }}>
            This password reset link is missing or invalid.
          </p>
          <Link to="/forgot-password" className="link-button">
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="login-container">
        <div className="login-box" style={{ textAlign: "center" }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "rgba(46, 125, 50, 0.12)",
              fontSize: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem",
            }}
          >
            ✅
          </div>
          <h2>Password updated!</h2>
          <p style={{ color: "var(--text-secondary, #666666)" }}>
            Redirecting you to login...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Set new password</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="new-password">New password</label>
            <input
              id="new-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              placeholder="At least 8 characters"
              minLength={8}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm password</label>
            <input
              id="confirm-password"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              placeholder="Repeat your new password"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={status === "submitting"}>
            {status === "submitting" ? "Updating..." : "Update password"}
          </button>
        </form>
        <p className="toggle-form">
          <Link to="/login" className="link-button">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ResetPassword;
